import classNames from 'classnames'
import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setMapMode, setMapTheme } from '../../../store/map/mapSlice'
import { MAP_MODES, MAP_THEMES } from '../../../store/map/map.constants'
import { selectMapMode, selectMapTheme } from '../../../store/map/map.selectors'
import T from '../../i18n/T'
import SVGIcon from '../../svg/SVGIcon'
import useEventCallback from '../../utils/useEventCallback'
import s from './LayerButtons.less'
import { TAG_CLICK_EVENT_MODE } from '../../analytics/analytics.tagids.constants'
import TagActionButton from '../../genericComponents/TagActionButton'

export const ModeMapEventLayerButton = ({
  id,
  disabled,
  active,
  icon,
  label,
  ariaLabel,
  tooltipLabel,
  clickAction
}) => {
  const onClick = useEventCallback(() => {
    clickAction()
  }, [clickAction])

  return (
    <TagActionButton
      onClick={onClick}
      className={classNames(s.layerButton, s.modeButton, active && s.activeButton, disabled && s.disabledLayerButton)}
      type={TAG_CLICK_EVENT_MODE}
    >
      <div className="icon">
        <SVGIcon url={icon} className={classNames(disabled && s.greyedIcon)} />
      </div>
      <span className={classNames(s.label, disabled && s.disabledLabel)} aria-label={ariaLabel} title={tooltipLabel}>
        {label}
      </span>
    </TagActionButton>
  )
}

export const ModeLayerButton = ({
  icon,
  activeIcon,
  hoverIcon,
  id,
  disabled,
  isEventMode,
  label,
  ariaLabel,
  tooltipLabel
}) => {
  const dispatch = useDispatch()
  const active = id === useSelector(selectMapMode).mode

  if (active && disabled) dispatch(setMapMode(MAP_MODES.neutral))

  const clickAction = useCallback(() => dispatch(setMapMode(active ? MAP_MODES.neutral : id)), [active, id])

  const onClick = useEventCallback(() => clickAction(), [clickAction])

  if (isEventMode)
    return (
      <ModeMapEventLayerButton
        id={id}
        disabled={disabled}
        active={active}
        icon={icon}
        label={label}
        ariaLabel={ariaLabel}
        tooltipLabel={tooltipLabel}
        clickAction={clickAction}
      />
    )

  return (
    <div
      onClick={onClick}
      className={classNames(s.layerButton, s.modeButton, active && s.activeButton, disabled && s.disabledLayerButton)}
    >
      <div className="icon">
        <SVGIcon icon={icon} className={classNames(disabled && s.greyedIcon)} />
      </div>
      <span className={classNames(s.label, disabled && s.disabledLabel)}>
        <T id={`map.tools.layers.${id}`} />
      </span>
    </div>
  )
}

export const ThemeLayerButton = ({ icon, id, disabled }) => {
  const dispatch = useDispatch()
  const active = id === useSelector(selectMapTheme)

  if (active && disabled) dispatch(setMapTheme(MAP_THEMES.normal))

  const onClick = useEventCallback(() => dispatch(setMapTheme(active ? MAP_THEMES.normal : id)), [active, id])

  return (
    <div
      onClick={onClick}
      className={classNames(s.layerButton, active && s.activeButton, disabled && s.disabledLayerButton)}
    >
      <div className="icon">
        <img src={icon} className={classNames(disabled && s.greyedIcon)} />
      </div>
      <span className={classNames(s.label, disabled && s.disabledLabel)}>
        <T id={`map.tools.layers.${id}`} />
      </span>
    </div>
  )
}
